import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  getAgentAssignmentPool,
  getConfigurations,
  selectAgentAssignmentPoolState,
  selectConfigurations,
  updateAgentAssignmentPool
} from './state/configurationsSlice'
import { userProfile } from '@views/profile/state/profileSlice'
import { Role } from '@types'
import { Box } from '@material-ui/core'
import ConfigurationBox from './components/ConfigurationBox'
import AgentAssignmentPoolSection from './components/AgentAssignmentPoolSection'
import './configurations.css'

const Configurations: React.FC = () => {
  const dispatch = useDispatch()
  const { role } = useSelector(userProfile)
  useEffect(() => {
    if (role === Role.admin) {
      dispatch(getConfigurations())
      dispatch(getAgentAssignmentPool())
    }
  }, [dispatch, role])
  const configurations = useSelector(selectConfigurations)
  const poolState = useSelector(selectAgentAssignmentPoolState)

  return (
    <div className="configurations-view">
      <Box className="configuration-cards-grid">
        {configurations.map(config => (
          <ConfigurationBox
            key={config.name}
            value={config.value}
            label={config.label}
            type={config.type}
            name={config.name}
            metadata={config.metadata}
          />
        ))}
      </Box>
      <Box className="configuration-pool-row">
        <AgentAssignmentPoolSection
          role={role}
          overview={poolState.overview}
          isLoading={poolState.isLoading}
          isUpdating={poolState.isUpdating}
          error={poolState.error}
          onSave={(executiveIds, expectedNextExecutiveId) =>
            dispatch(updateAgentAssignmentPool({ executiveIds, expectedNextExecutiveId }))
          }
        />
      </Box>
    </div>
  )
}

export default Configurations
